export const ChatFloatIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="20"
    viewBox="0 0 22 20"
    fill="none">
    <path
      d="M6.47729 6.19727H15.1173"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <path
      d="M6.47729 10.5172H12.9573"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <path
      d="M7.55727 15.9172H4.31727C3.45797 15.9172 2.63386 15.5759 2.02624 14.9683C1.41863 14.3607 1.07727 13.5365 1.07727 12.6772V4.03724C1.07727 3.17794 1.41863 2.35383 2.02624 1.74622C2.63386 1.1386 3.45797 0.797241 4.31727 0.797241H17.2773C18.1366 0.797241 18.9607 1.1386 19.5683 1.74622C20.1759 2.35383 20.5173 3.17794 20.5173 4.03724V12.6772C20.5173 13.5365 20.1759 14.3607 19.5683 14.9683C18.9607 15.5759 18.1366 15.9172 17.2773 15.9172H14.0373L10.7973 19.1572L7.55727 15.9172Z"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
  </svg>
);
